import { set } from 'lodash/fp';
import createReducer from '../../../../helpers/createReducer';
import {
  paginationState,
  resetPaginationState
} from '../../../../helpers/pagination';
import {
  createFetchOneHandler,
  createFetchManyHandler,
  createSaveHandler,
  createUpdateHandler,
  createDeleteHandler
} from '../../../../helpers/reducerRoutineCrudHandler';
import {
  fetchInventoryItem,
  fetchInventoryItems,
  createInventoryItem,
  updateInventoryItem,
  deleteInventoryItem
} from '../../sagas/routines';
import {
  clearInventoryItems,
  inventoryItemsOnChangePage,
  resetInventoryItemDeleted,
  inventoryItemsOnChangeOrder
} from '../../actions/item';

const initialState = {
  all: {},
  fetched: false,
  fetching: false,
  fetchingError: null,
  saved: false,
  saving: false,
  savingError: null,
  deleted: false,
  deleting: false,
  deletingError: null,
  pagination: paginationState(),
  order: 'id:desc'
};

const clearItemsHandler = action => ({
  [action.toString()]: state => ({
    ...state,
    all: {},
    pagination: resetPaginationState(state.pagination)
  })
});

const updateInventoryItemsCurrentPageHandler = action => ({
  [action.toString()]: (state, { payload: page }) =>
    set('pagination.currentPage', page, state)
});

const updateInventoryItemsOnChangeOrderHandler = action => ({
  [action.toString()]: (state, { payload: order }) => set('order', order, state)
});

const resetDeletedHandler = action => ({
  [action.toString()]: set('deleted', false)
});

export default createReducer(initialState, {
  ...createFetchOneHandler(fetchInventoryItem),
  ...createFetchManyHandler(fetchInventoryItems),
  ...createSaveHandler(createInventoryItem),
  ...createUpdateHandler(updateInventoryItem),
  ...createDeleteHandler(deleteInventoryItem),
  ...resetDeletedHandler(resetInventoryItemDeleted),
  ...clearItemsHandler(clearInventoryItems),
  ...updateInventoryItemsCurrentPageHandler(inventoryItemsOnChangePage),
  ...updateInventoryItemsOnChangeOrderHandler(inventoryItemsOnChangeOrder)
});
